import React from 'react';
import TransferTopBar from './TransferTopBar';

/**
 * The Transfer Site template's header for every page except the landing: the same
 * menu bar as the landing, on a solid bar that stays at the top while scrolling.
 * It is IN the page flow (sticky, not fixed): its height follows the logo size set in
 * General Settings and the content always starts below it. A fixed bar with a hard-coded
 * top padding on every page is what let a larger logo cover the page title.
 * Solid on purpose - a blurred/filtered ancestor would trap the mobile slide-out
 * menu (it is position:fixed) inside the bar.
 */
const TransferSiteHeader = ({ dark = false, onToggleTheme }) => (
  <div className={`sticky top-0 z-40 border-b ${dark ? 'bg-slate-950 border-white/10' : 'bg-white border-slate-200'}`}
    data-testid="transfer-site-header">
    <TransferTopBar dark={dark} tone="bar" onToggleTheme={onToggleTheme} showThemeToggle={Boolean(onToggleTheme)} />
  </div>
);

export default TransferSiteHeader;
